import React from 'react';
import MuiTextField from '@material-ui/core/TextField';
import { fieldToTextField } from 'formik-material-ui';

export const TriggeringTextField = ({onChange, ...props}) => (
  <MuiTextField
    {...fieldToTextField(props)}
    onChange={onChange}
  />
);

export const onNameChange = (e, setFieldValue, values) => {
  const elderly_name = e.target.value;
  setFieldValue('elderly_name', elderly_name);
  if (values.request_type === 'Exclusivo') {
    setFieldValue('subject', `Possibilidade de admissão de ${elderly_name}`, false);
  }
};

